import { Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";

import { TextInputProps } from "../../../interfaces";
import { nameRegex, noEmojiRegex } from "utils";
import {
  erroreCampoObbligatorio,
  erroreCaratteriNonValidi,
  errorMaxLength,
  errorSourceTitleName,
  errorTopicName,
} from "../../../_constants";
import { useAppDispatch, useAppSelector } from "store/store";
import { forwardRef, useEffect } from "react";
import { setNameTopicValidation } from "store/slicer/FormTopicValidationSlice";
import { setAddSourceNameValidation } from "store/slicer/FormAddSourceValidationSlice";

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      control,
      name,
      placeholder,
      maxLength,
      trigger,
      required = true,
      onlyLetters = true,
      focusOutFunction,
      validationRules,
      showError = true,
      noEmoji = true,
      disabled,
    }: TextInputProps,
    ref
  ) => {
    const dispatch = useAppDispatch();
    const isNameValid = useAppSelector(
      (state) => state.formTopicValidationSlice.nameTopicIsValid
    );
    const isSourceNameValid = useAppSelector(
      (state) => state.formAddSourceValidationSlice.addSourceNameIsValid
    );

    const resetRegisterValidationStatus = () => {
      dispatch(setNameTopicValidation(true));
      dispatch(setAddSourceNameValidation(true));
    };
    useEffect(() => {
      if (trigger && control._getDirty()) {
        trigger(name);
      }
    }, [isNameValid, isSourceNameValid, trigger, control, name]);

    return (
      <Controller
        name={name}
        control={control}
        rules={{
          required: required ? erroreCampoObbligatorio : false,
          maxLength: {
            value: maxLength ?? 1024,
            message: `${errorMaxLength} ${maxLength}`,
          },
          validate: {
            onlyLetters: (value) =>
              !onlyLetters ||
              nameRegex.test(value) ||
              !value?.length ||
              erroreCaratteriNonValidi,
            noEmoji: (value) =>
              !noEmoji || !noEmojiRegex.test(value) || erroreCaratteriNonValidi,
            nameTopicCheck: () => {
              if (!isNameValid) return errorTopicName;
              return true;
            },
            nameSourceCheck: () => {
              if (!isSourceNameValid) return errorSourceTitleName;
              return true;
            },
            ...validationRules,
          },
        }}
        render={({ field, fieldState: { error } }) => (
          <div className="flex-container column height-100">
            <InputText
              id={field.name}
              {...field}
              ref={ref}
              className={`${
                error && showError ? "p-invalid margin-bottom-4" : ""
              }`}
              placeholder={placeholder}
              onFocus={resetRegisterValidationStatus}
              disabled={disabled}
              onBlur={() => {
                if (!error && focusOutFunction) {
                  focusOutFunction(field.value);
                }
              }}
            />

            {error && showError && (
              <small className="p-error margin-bottom-4">{error.message}</small>
            )}
          </div>
        )}
      />
    );
  }
);
